import { getCourses } from '../../api';
import { useListFetch, useLogo } from '../../hooks';
import type { CoursesListType } from '../../api';

export const useCourses = () => {
  const {
    intializing: loading,
    nodes,
    pagination,
  } = useListFetch<CoursesListType>(
    params =>
      getCourses(
        params?.pagination?.page,
        params?.pagination?.perPage,
        params?.sort
      ),
    { deps: [] }
  );

  useLogo(nodes);

  return {
    loading,
    courses: nodes || [],
    pagination,
  };
};

export type { CourseType, LessonType, CoursesListType } from '../../api';
